


















import { PropType } from 'vue';

import { ContractPhaseEnum, IContract } from '@/models';

import auth from '@/mixins/auth';
import snackbar from '@/mixins/snackbar';
import mixins from '@/utils/mixins';

import ContractBuilderDialog from '@/components/contract/ContractBuilderDialog.vue';
import ContractStateActions from './ContractStateActions.vue';
import StateCard from '@/components/common/StateCard.vue';

const baseMixins = mixins(auth, snackbar);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    contactBuilderDialog: InstanceType<typeof ContractBuilderDialog>;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'ContractStateCard',

    components: {
      ContractBuilderDialog,
      ContractStateActions,
      StateCard
    },

    props: {
      contract: {
        type: Object as PropType<IContract>
      }
    },

    computed: {
      getPhaseIcon(): string {
        switch (this.contract.phase) {
          case ContractPhaseEnum.Draft:
            return 'mdi-file-document-outline';

          case ContractPhaseEnum.Active:
            return 'mdi-check';

          case ContractPhaseEnum.Pending:
            return 'mdi-alert';

          case ContractPhaseEnum.Expired:
          default:
            return 'mdi-close';
        }
      },

      getPhaseColor(): string {
        return this.contract.getPhaseColor();
      },

      getPhaseMessage(): string {
        return this.contract.getPhaseMessage();
      }
    },

    methods: {
      openContractWizardFormDialog() {
        this.$refs.contactBuilderDialog.open(this.contract);
      }
    }
  });
